import { format } from 'date-fns';
import { nb } from 'date-fns/locale';
import { Faktura, FakturaType } from 'src/app/services/faktura/faktura.types';

export function getFakturaPeriodString(fra: string, til: string) {
  const fraDato = format(new Date(fra), 'd. MMM', { locale: nb });
  const tilDato = format(new Date(til), 'd. MMM', { locale: nb });
  return `${fraDato} – ${tilDato}`;
}

export function getValgtFakturering(fakturamaate: string): FakturaType {
  if (fakturamaate === 'Epost') return 'EPOST';
  if (fakturamaate === 'SMS') return 'SMS';
  if (fakturamaate === 'Brev') return 'PAPIR';
  return undefined;
}

export function harRegningForfalt(faktura: Faktura): boolean {
  const forfall = new Date(faktura.endeligForfall);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  forfall.setHours(0, 0, 0, 0);
  return today > forfall;
}

export function erRegningBetalt(faktura: Faktura): boolean {
  return faktura.status.trim() !== 'Ikke betalt';
}

export function dagerTilForfall(faktura: Faktura) {
  const dato =
    !faktura.kanUtsette &&
    faktura.betalingsavtale &&
    !harRegningForfalt(faktura)
      ? faktura.endeligForfall
      : faktura.forfdato;

  const forfall = new Date(dato);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  forfall.setHours(0, 0, 0, 0);
  const diffTime = Math.abs(forfall.valueOf() - today.valueOf());
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}

export function dagerTilForfallTekst(faktura: Faktura) {
  const daysUntil = dagerTilForfall(faktura);
  if (isNaN(daysUntil)) {
    return (
      'Forfall: ' +
      (!faktura.kanUtsette && faktura.betalingsavtale
        ? faktura.endeligForfall
        : faktura.forfdato)
    );
  }
  if (daysUntil === 0) {
    return 'Forfaller i dag';
  }
  return harRegningForfalt(faktura)
    ? `${daysUntil} dager siden forfall`
    : `${daysUntil} dager til forfall`;
}
